import * as React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { ActivitySchedule } from '../../../model/activities';
import { ReservationsList } from './ReservationsList';
import { ReservationsHeader } from './ReservationsHeader';
import { contact } from '../../../model/contact';

interface IProps {
    open: boolean;
    loading: boolean;
    onCancel: () => any;
    onAddReservation: (contact:contact, schedule:ActivitySchedule) => any;
    onRemoveReservation: (scheduleId:string, id:string) => any;
    schedule: ActivitySchedule;
    classes: any;
}
export const ReservationsDialog = (props: IProps) => {
    return <Dialog
        open={props.open}
        onClose={(e) => props.loading ? {} : props.onCancel()}
        maxWidth={"lg"}
        classes={{
            paper: props.classes.reservationDialog
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">Prenotazioni {props.schedule.displayName}</DialogTitle>
        <DialogContent className={props.classes.reservationSlotDetailDialogContent}>
            <ReservationsHeader schedule={props.schedule} classes={props.classes} addReservation={props.onAddReservation}></ReservationsHeader>
            <ReservationsList reservations={props.schedule.reservations} loading={false} classes={props.classes} removeReservation={props.onRemoveReservation}></ReservationsList>
        </DialogContent>
    </Dialog>
}